import { render, staticRenderFns } from "./TableDataCell.vue?vue&type=template&id=5c978325&scoped=true"
import script from "./TableDataCell.vue?vue&type=script&lang=js"
export * from "./TableDataCell.vue?vue&type=script&lang=js"
import style0 from "./TableDataCell.vue?vue&type=style&index=0&id=5c978325&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c978325",
  null
  
)

export default component.exports